// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-row[data-v-55d3eb52] {\r\n  margin-bottom: 10px;\n&:last-child {\r\n    margin-bottom: 0;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
